module.exports = __webpack_public_path__ + "img/card-front.7605c638.jpg";